module.exports = new __parcel__URL__("neon_gold_storage_level_12.7c9568db.png").toString();